/* eslint-disable react-hooks/exhaustive-deps */
import useConfig from '@/Components/Hooks/useConfig';
import SmartHome from '@/Components/SmartHome/SmartHome';
import { CONFIG_BIOMETRICS_ENABLE_KEY, CONFIG_SMARTHOME_ENABLE_KEY } from '@/constants/device';
import { getLocaleTime } from '@/utilities/helpers/commonHelper';
import { getCurrentUser } from '@vantiva-sa/homesight_humaui/Store/authStore';
import { getCurrentLanguage, translator } from '@vantiva-sa/homesight_humaui/Store/configStore';
import {
  getProfilePics,
  getUserConfig,
  getUserInfo,
} from '@vantiva-sa/homesight_humaui/Store/dataStore';
import { getPermissions } from '@vantiva-sa/homesight_humaui/Store/permisssionsStore';
import { startVideoCall } from '@vantiva-sa/homesight_humaui/Store/videoCallStore';
import {
  isActionAllowed,
  KnownActionsList,
} from '@vantiva-sa/homesight_humaui/Utilities/AccessControl';
import {
  getDisplayLanguage,
  getProfilePicUrl,
  getUsername,
} from '@vantiva-sa/homesight_humaui/Utilities/CommonUtilities';
import { Actions, PhotoResolution } from '@vantiva-sa/homesight_humaui/Utilities/Constants';
import { Divider, Tooltip } from 'antd';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import MainPage from '../../MainPage';
import AccountSetupSection from '../AccountSetupComponent/AccountSetupSection';
import CallActivity from '../CallActivity/CallActivity';
import ContentActivity from '../ContentActivity/ContentActivity';
import {
  CallIconNew,
  ContactImage,
  EditNewIcon,
  LimitedAccessIcon,
  MapIcon,
  MessageIcon,
  NewAutoCallIcon,
  NewHC200Icon,
  SyncIcon,
  UnassignedHS200DeviceIcon,
  UserHubsDoBIcon,
  UserHubsGenderIcon,
  UserHubsIncompleteContactImage,
} from '../Common/Icons';
import { isTimeZoneValid } from '../Common/TimezoneUtils';
import ContactForm from '../Contacts/ContactForm';
import { Contacts } from '../Contacts/Contacts';
import Dashboard from '../Dashboard/Dashboard';
import DeviceInventory from '../DeviceInventory/DeviceInventory';
import { getTranslatedLocationName } from '../DeviceInventory/DeviceInventoryList';
import { useAssignSmartCameraHandler } from '../DeviceInventory/useAssignSmartCameraHandler';
import RebootResetModal from '../Devices/RebootResetModal';
import useDevicesList from '../Hooks/useDevicesList';
import useUserInfo from '../Hooks/useUserInfo';
import AutoCallModal from '../Modals/AutoCallModal';
import { getModalDataForCall } from '../Modals/AutoCallModalDataUtils';
import SendMessageModal from '../Modals/SendMessageModal';
import MotionActivity from '../MotionActivity/MotionActivity';
import Schedule from '../Schedule/Schedule';
import AssignStaff from '../Staff/AssignStaff';
import { useAssignStaffHandler } from '../Staff/NewAssignStaff/useAssignStaffHandler';
import UserHubModal from '../UserHubs/UserHubModal';
import EditUserProfile from '../UserProfile/EditUserProfile';
import Wellness from '../Wellness/Wellness';
import Gallery from '../Gallery/Gallery';

const HubDetailsComponent = ({
  header,
  hubRecord,
  openSubMenu,
  onActionClick,
  rolename,
  tabSwitch,
  activeSubMenuContent,
  userHubCall,
  sendMsgDisplay = false,
  navigationKey = false,
  userHubsData,
  offset,
  limit,
  showContactingStaff,
  loginUserTimeformat,
  fetchUserHubs,
  principalRecord = {},
  parentActionClick,
  onUserHubActionClick,
  loginUserMeasurementUnit,
}) => {
  const dispatch = useDispatch();
  const trans = useSelector(translator);
  const location = useLocation();
  const path = location.pathname.split('/')[1]?.toLowerCase();
  const useruuid = useMemo(() => hubRecord?.useruuid, [hubRecord]);
  const userData = useSelector((user) => user.data.userInfo);
  const updatedUserInfo = userData[useruuid];
  const resourcesMap = useSelector(getProfilePics());
  const currentUser = useSelector(getCurrentUser);
  const { providerid } = useMemo(() => currentUser, [currentUser]);
  const addressParts = [
    updatedUserInfo?.address,
    updatedUserInfo?.city,
    updatedUserInfo?.province,
    updatedUserInfo?.postalcode,
  ].filter((value) => value && value.trim() !== '');

  const hasAddressInfo = addressParts.length > 0;

  const { data: userInfo = {}, refetch: fetchUserInfo } = useUserInfo({
    useruuid: hubRecord?.useruuid,
    queryOptions: { staleTime: 0, refetchOnMount: 'always' },
  });
  const accountUserName = getUsername(updatedUserInfo);
  const hubUseruuid = hubRecord?.useruuid;

  // Fetch config/merged API for the hub user
  const { data: hubConfig = {} } = useConfig({ useruuid: hubUseruuid });
  const isSmartHomeEnabled = useMemo(
    () => get(hubConfig, CONFIG_SMARTHOME_ENABLE_KEY, true),
    [hubConfig]
  );
  const isBiometricsEnabled = useMemo(
    () => get(hubConfig, CONFIG_BIOMETRICS_ENABLE_KEY, true),
    [hubConfig]
  );
  const [headerRefreshKey, setHeaderRefreshKey] = useState(0);

  const [fetchingDevicesData, fetchDevices, devicesData] = useDevicesList({
    providerid,
  });
  const [deviceStatus, setDeviceStatus] = useState('');
  const [deviceLocation, setDeviceLocation] = useState(null);
  const [statusTitle, setStatusTitle] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isCallModalOpen, setIsCallModalOpen] = useState(false);
  const [isMessageModalOpen, setIsMessageModalOpen] = useState(false);
  const [hubMessageData, setHubMessageData] = useState('');
  const queryParams = { filterkey: 'useruuid', filtervalue: useruuid };
  const [selectedHub, setSelectedHub] = useState('');
  const [headerKeyActionType, setHeaderKeyActionType] = useState(null);
  const [hasDevice, setHasDevice] = useState(false);
  const [assignDeviceID, setAssignDeviceID] = useState(null);
  const numOfAdminContacts = updatedUserInfo?.numofadmincontacts ?? hubRecord?.numofadmincontacts;
  const currentUseruuid = useMemo(() => currentUser?.useruuid, [currentUser]);
  const currentUserConfig = useSelector(getUserConfig(currentUseruuid));
  const currentLanguage = useSelector(getCurrentLanguage);
  const currentUserInfo = useSelector(getUserInfo(currentUseruuid));
  const translatedLocation = useMemo(
    () => getTranslatedLocationName(deviceLocation, currentUserConfig, currentLanguage),
    [deviceLocation, currentUserConfig, currentLanguage]
  );

  const shouldDisplayDemographicSection = (hubRecord) => {
    const isStaff = currentUser?.permission_level === 'Staff';
    const isStaffAdmin = currentUser?.permission_level === 'Staff Admin';
    const isManageRole = hubRecord?.rolename === 'Manage';
    const isCareRole = hubRecord?.rolename === 'Care';
    const allowedForStaff = isStaff && (isManageRole || isCareRole);
    const allowedForStaffAdmin = isStaffAdmin;
    return allowedForStaff || allowedForStaffAdmin;
  };
  const displayDemographicInfo =
    shouldDisplayDemographicSection(hubRecord) &&
    currentUserConfig?.homesight_web_config?.web_config?.display_demographic_info;

  const [activeTab, setActiveTab] = useState(tabSwitch ? tabSwitch : 'schedule'); // State to manage the active tab

  const {
    isSmartCameraModalOpen,
    readyToAssignDevices,
    searchText,
    setSearchText,
    searchApplied,
    selectedSmartCameraDevice,
    readyToAssignloading,
    handleDeviceSmartCameraSelect,
    handleSearchApply,
    handleClearSearch,
    handleAssignSmartCamera,
    closeModal,
    assignDevice,
    handleAssignSmartCameraList,
    refetch,
    dataFetched,
    accessoriesData,
  } = useAssignSmartCameraHandler(fetchDevices, hubRecord);
  const {
    isFirstModalOpen,
    openAssignStaffModal,
    handleCloseFirstModal,
    selectedStaff,
    handleAddStaff,
    mOrderedStaffList,
    fetchingStaffList,
    formData,
    handleAssignStaff,
    handleRoleSelection,
    handleInputChange,
    handleOpenSecondModal,
    handleCloseSecondModal,
    isSecondModalOpen,
    setSelectedStaff,
    role,
    setSearchNameApplied,
    searchNameApplied,
    setSearchNameText,
    searchNameText,
  } = useAssignStaffHandler(hubRecord, onActionClick, openSubMenu, {
    triggerApi: activeTab === 'schedule',
  });

  const deviceID = useMemo(() => {
    if (headerKeyActionType === 'remove_device') {
      return '';
    }
    if (headerKeyActionType === 'assign_device') {
      return assignDeviceID;
    }
    if (devicesData?.length > 0) {
      //   const hub = userHubs?.find((hub) => hub.useruuid === useruuid);
      //   return hub?.hubname || "";
      // }
      // Use the assigned device logic if a device has been assigned
      if (hasDevice) {
        const assignedDevice = devicesData.find((d) => d.deviceuuid === hubRecord?.deviceuuid);
        if (assignedDevice) {
          return assignedDevice.deviceid || '';
        }
      }
    }
    return '';
  }, [devicesData, headerRefreshKey, headerKeyActionType, hasDevice]);

  const setHeaderRefreshKeyHandler = (actionType, deviceID = '') => {
    setHeaderKeyActionType(actionType);
    if (actionType === 'remove_device') {
      setHasDevice(false);
    }
    if (actionType === 'assign_device') {
      setHasDevice(true);
      setAssignDeviceID(deviceID);
    }
  };

  const handleTabChange = (key) => {
    setActiveTab(null);
    setTimeout(() => {
      setActiveTab(key);
      path === 'devices'
        ? onActionClick(Actions.listHub, hubRecord, offset, limit)()
        : onActionClick(Actions.hubDetails, hubRecord, true, false)();
    }, 50);
  };

  const getTranslatedRole = (rolename) => {
    switch (rolename) {
      case 'Manage':
        return trans('MANAGE');
      case 'Social':
        return trans('SOCIAL');
      case 'Care':
        return trans('CARE');
      default:
        return rolename;
    }
  };

  const image = useMemo(
    () => selectedHub?.profilePics && selectedHub?.profilePics[PhotoResolution.R128],
    [selectedHub]
  );
  // permission for personal information of manage and care role
  const allowPersonalInfoAccessForAdmin = useMemo(() => {
    const isStaffAdmin = currentUser?.permission_level?.includes('Staff Admin');
    const isStaff = currentUser?.permission_level?.includes('Staff');
    const hasManageRole = hubRecord?.rolename?.includes('Manage');
    if (isStaffAdmin) return true;
    if (isStaff && hasManageRole) return true;
    return false;
  }, [openSubMenu, currentUser, hubRecord, displayDemographicInfo]);

  const videoCallNotificationModalVisible = useSelector(
    (state) => state.notification.videoCallNotificationModalVisible
  );

  useEffect(() => {
    if (videoCallNotificationModalVisible) {
      setIsCallModalOpen(false);
      setShowModal(false);
    }
  }, [videoCallNotificationModalVisible]);

  const handleModal = (hubRecord) => {
    setShowModal(true);
    setSelectedHub(hubRecord);
  };

  const cancelModal = () => {
    setShowModal(false);
  };

  const handleSendMessage = () => {
    setIsModalOpen(true);
    setHubMessageData(modalDataForSendMessage);
  };

  const cancelSendMessage = () => {
    setIsModalOpen(false);
  };

  const handleCallModal = () => {
    setIsCallModalOpen(true);
  };

  const cancelCallModal = () => {
    setIsCallModalOpen(false);
  };

  const handleMessageModal = () => {
    setIsMessageModalOpen(true);
    setSelectedHub(hubRecord);
  };

  const cancelMessageModal = () => {
    setIsMessageModalOpen(false);
    setSelectedHub('');
  };

  const filteredUserHubsData = useMemo(() => {
    if (userHubsData && navigationKey) {
      return userHubsData.filter((hub) => hub.useruuid === hubRecord?.useruuid);
    }
  }, [hubRecord?.useruuid, userHubsData]);

  const hubUserRole = useMemo(() => {
    return navigationKey
      ? filteredUserHubsData && filteredUserHubsData.length > 0 && filteredUserHubsData[0]?.rolename
      : hubRecord?.rolename;
  }, [navigationKey, filteredUserHubsData, hubRecord]);

  const modalData = {
    image: image,
    devicename: getUsername(selectedHub),
    status: trans('OFFLINE'),
    cancel: cancelModal,
  };

  const modalDataForSendMessage = {
    title: <div className="messagetitle">{trans('DEVICEOFFLINE')}</div>,
    description: <div className="messagedescription">{trans('MESSAGEISNOTSENT')}</div>,
    action: '',
    icon: <NewHC200Icon status={'disconnected'} />,
    dismiss: cancelSendMessage,
  };

  useEffect(() => {
    if (devicesData?.length > 0) {
      const connectionStatus = devicesData[0].deviceconnectstatus.toLowerCase();
      const provisioningStatus = devicesData[0].provisioningstatus.toLowerCase();
      let title = '';
      if (connectionStatus === 'connected') title = `${trans('ONLINE')}" | `;
      else title = `${trans('OFFLINE')}" | `;
      if (provisioningStatus === 'provisioned') title = title + trans('ASSIGNED');
      else title = title + trans('UNASSIGNED');
      setDeviceStatus(connectionStatus);
      // setStatusTitle(title);
      setStatusTitle(trans('WELLNESSHUB'));
      setDeviceLocation(devicesData[0]?.location);
    }
  }, [devicesData]);

  useEffect(() => {
    fetchDevices(queryParams);
  }, []);

  const permissions = useSelector(getPermissions());
  const allowCallContact = useMemo(
    () => isActionAllowed(hubUserRole, KnownActionsList.call_contacts, permissions),
    [hubUserRole, permissions]
  );
  const successCallback = () => {
    fetchUserInfo();
  };
  const allowAutoCall = userInfo?.autoacceptcall;

  // useMemo(
  //   () =>
  //     allowAutoVideoCall(
  //       navigationKey
  //         ? filteredUserHubsData &&
  //             filteredUserHubsData.length > 0 &&
  //             filteredUserHubsData[0]
  //         : hubRecord
  //     ) && checkRoleAccess(Access.videocall.allowAutoCall),
  //   [hubRecord, currentUser?.roles, filteredUserHubsData]
  // );
  const allowManageContacts = useMemo(
    () =>
      isActionAllowed(
        navigationKey
          ? filteredUserHubsData &&
              filteredUserHubsData.length > 0 &&
              filteredUserHubsData[0].rolename
          : hubRecord?.rolename,
        KnownActionsList.manage_contacts,
        permissions
      ),
    [hubRecord?.rolename, permissions, filteredUserHubsData]
  );

  const allowStaffAndStaffAdmin = useMemo(
    () =>
      (currentUser?.permission_level === 'Staff' && hubRecord?.rolename === 'Manage') ||
      currentUser?.permission_level === 'Staff Admin',
    [currentUser, hubRecord]
  );

  const hubRecordProfilePic = useMemo(
    () => getProfilePicUrl(useruuid, resourcesMap, PhotoResolution.R256),
    [hubRecord, resourcesMap]
  );

  const accountName = getUsername(updatedUserInfo);
  const renderName = <Tooltip title={accountName}>{accountName}</Tooltip>;

  const get_utc_offset = (timeZone) => {
    timeZone = timeZone.split(' ')[0];
    return Intl.DateTimeFormat(navigator.language, {
      timeZoneName: 'longOffset',
      timeZone,
    })
      .formatToParts()
      .find((i) => i.type === 'timeZoneName')
      .value.replace('GMT', '');
  };

  const getTimeZoneFullForm = useMemo(() => {
    if (!updatedUserInfo?.timezone) return;
    const timeZone = updatedUserInfo.timezone.split(' ')[0];
    if (!timeZone || !isTimeZoneValid(timeZone)) {
      console.warn('Invalid timezone', timeZone);
      return trans('INVALIDTIMEZONE');
    }
    const formatterLong = new Intl.DateTimeFormat('en-US', {
      timeZone: timeZone,
      timeZoneName: 'long',
    });
    const formatterShort = new Intl.DateTimeFormat('en-US', {
      timeZone,
      timeZoneName: 'short',
    });
    const longName = formatterLong
      .formatToParts(new Date())
      .find((part) => part.type === 'timeZoneName')?.value;

    const shortName = formatterShort
      .formatToParts(new Date())
      .find((part) => part.type === 'timeZoneName')?.value;

    return shortName && longName ? `${shortName} (${longName})` : longName;
  }, [updatedUserInfo?.timezone]);

  const modalDataForCall = useMemo(
    () => getModalDataForCall(hubRecord, cancelCallModal, dispatch, trans),
    [hubRecord, cancelCallModal, dispatch, trans]
  );

  useEffect(() => {
    if (devicesData.length === 0) {
      setDeviceStatus('');
      setDeviceLocation(null);
      setStatusTitle('');
      setHeaderRefreshKey((prev) => prev + 1);
    }
  }, [devicesData]);

  useEffect(() => {
    if (hubRecord?.deviceuuid) {
      setHasDevice(true);
    }
  }, [hubRecord]);

  const renderHeader = useMemo(
    () => (
      <header className="hub-header-container">
        <div className="hub-header-info-container">
          <div className="hub-header-image-container">
            {updatedUserInfo?.modified_time !== undefined && (
              <>
                {hubRecordProfilePic ? (
                  <>
                    <img
                      src={hubRecordProfilePic}
                      className={`hub-header-user-profile-pic ${
                        !updatedUserInfo?.modified_time || !hasDevice || numOfAdminContacts === 0
                          ? 'yellow-border'
                          : 'image'
                      }`}
                      alt=""
                    />
                    {(!updatedUserInfo?.modified_time || !hasDevice || numOfAdminContacts == 0) && (
                      <div className="incomplete-container">
                        <span className="incomplete-text">{trans('INCOMPLETE')}</span>
                      </div>
                    )}
                  </>
                ) : !updatedUserInfo?.modified_time || !hasDevice || numOfAdminContacts === 0 ? (
                  <UserHubsIncompleteContactImage
                    text={trans('INCOMPLETE')}
                    className="hub-header-incomplete-contact-image"
                  />
                ) : (
                  <ContactImage className="hub-header-user-profile-pic svg" />
                )}
              </>
            )}
          </div>
          <div className="hub-header-info">
            <label className="hub-header-user-name">{renderName}</label>
            <div className="hub-header-profile-info-main-container">
              {displayDemographicInfo ? (
                <div className="hub-header-description-part-1">
                  <div className="hub-header-gender-detail-container">
                    <UserHubsGenderIcon className="hub-header-gender-icon" />
                    <span className="hub-header-gender-label">
                      {updatedUserInfo?.gender
                        ? trans(updatedUserInfo.gender.toUpperCase().replace(/\s/g, ''))
                        : trans('NOTKNOWN')}
                    </span>
                  </div>
                  <div className="hub-header-dob-detail-container">
                    <UserHubsDoBIcon className="hub-header-dob-icon" />
                    <span className="hub-header-dob-label">
                      {updatedUserInfo?.dateofbirth
                        ? getLocaleTime(updatedUserInfo?.dateofbirth, currentUserInfo?.locale)
                        : trans('NOTKNOWN')}
                    </span>
                  </div>
                  {hasAddressInfo && (
                    <Tooltip
                      title={addressParts.join(', ')}
                      placement="bottom"
                      style={{ maxWidth: '400px', width: 'auto' }}
                    >
                      <div className="hub-header-address-detail-container">
                        <MapIcon className="hub-header-address-icon" fillColor="#003252" />
                        <span className="hub-header-address-label">{addressParts.join(', ')}</span>
                      </div>
                    </Tooltip>
                  )}
                </div>
              ) : (
                <div className="hub-header-description-empty-placeholder"></div>
              )}
              <div className="hub-header-user-role-container">
                <label className="hub-header-user-role-locale">
                  {getDisplayLanguage(updatedUserInfo?.locale)}
                </label>
                <Divider
                  className="divider"
                  type="vertical"
                  style={{
                    border: '1px solid #C9C9C9',
                    margin: '1px 8px',
                    height: '18px',
                  }}
                />
                <label className="user-role-timezone">{getTimeZoneFullForm}</label>
                <div className="hub-header-edit-profile-container">
                  {(allowStaffAndStaffAdmin || allowManageContacts) && (
                    <>
                      <div
                        className="hub-header-edit-profile-block"
                        onClick={() => {
                          setActiveTab('editProfile');
                        }}
                      >
                        <EditNewIcon className="hub-edit-icon" />
                        <span className="hub-header-edit-profile-label">
                          {trans('EDIT_U_PROFILE_L')}
                        </span>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="hub-action-device-container">
          <div className="header-action-buttons">
            {allowCallContact && !!deviceStatus && allowAutoCall !== undefined && (
              <>
                <Tooltip title={trans('VIDEOCALL')}>
                  <div
                    className="action"
                    disabled={fetchingDevicesData}
                    onClick={() => {
                      deviceStatus === 'connected'
                        ? allowAutoCall
                          ? handleCallModal()
                          : dispatch(
                              startVideoCall({
                                callees: [hubRecord],
                                hubRecord,
                              })
                            )
                        : handleModal(hubRecord);
                    }}
                  >
                    {allowAutoCall ? <NewAutoCallIcon /> : <CallIconNew />}
                  </div>
                </Tooltip>
                {sendMsgDisplay && (
                  <MessageIcon
                    className="action"
                    onClick={deviceStatus === 'connected' ? handleMessageModal : handleSendMessage}
                  />
                )}
              </>
            )}
          </div>
          {hasDevice && sendMsgDisplay && allowCallContact && (
            <div
              className="divider"
              type="vertical"
              style={{
                border: '1px solid #C9C9C9',
                margin: '1px 8px',
                height: '80px',
              }}
            ></div>
          )}
          <div className="header-device-info-container">
            <div className="header-device-description-container">
              <p className="title-1">{translatedLocation}</p>
              <p className="title-2">{statusTitle}</p>
              <p className="title-3">
                {deviceID ? (deviceID.length <= 12 ? deviceID : deviceID.substring(0, 12)) : ''}
              </p>
            </div>
            {hasDevice ? (
              <NewHC200Icon status={deviceStatus} className="icon" />
            ) : (
              <UnassignedHS200DeviceIcon />
            )}
            <Tooltip title={trans('REFRESH')}>
              <div className="refreshicon">
                <SyncIcon
                  onClick={() => fetchDevices(queryParams)}
                  style={{ cursor: 'pointer', padding: '2px' }}
                />
              </div>
            </Tooltip>
          </div>
        </div>
      </header>
    ),
    [
      headerRefreshKey,
      hubRecord,
      deviceStatus,
      deviceLocation,
      statusTitle,
      useruuid,
      updatedUserInfo,
      deviceID,
      userInfo,
      trans,
    ]
  );

  const renderProfileSection = () => {
    const truncateName = (name) => {
      return name.length > 15 ? name.substring(0, 15) + '...' : name;
    };
    return (
      <div className="submenu-account-selected-container">
        <div className="submenu-account-selected-content">
          {hubRecordProfilePic ? (
            <img src={hubRecordProfilePic} className="submenu-profile-container image" alt="" />
          ) : (
            <ContactImage className="submenu-profile-container" />
          )}
          <div className="submenu-profile-name-role-container">
            <div className="submenu-profile-name-block">
              <Tooltip title={accountName}>
                <span className="name-label">{truncateName(accountName)}</span>
              </Tooltip>
            </div>
            <div className="submenu-profile-name-block">
              {hubRecord?.rolename ? (
                <span className="role-label">{getTranslatedRole(hubRecord?.rolename)}</span>
              ) : (
                <span className="role-label">
                  <LimitedAccessIcon />
                  {trans('LIMITEDACCESS')}
                </span>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      {isModalOpen && <RebootResetModal data={hubMessageData} />}
      {showModal && <UserHubModal data={modalData} />}
      {isCallModalOpen && <AutoCallModal data={modalDataForCall} />}
      {isMessageModalOpen && (
        <SendMessageModal
          useruuid={useruuid}
          trans={trans}
          record={hubRecord}
          selectedHub={selectedHub}
          onActionClick={onActionClick}
          cancelMessageModal={cancelMessageModal}
          onUserHubActionClick={onUserHubActionClick}
        />
      )}
      <MainPage
        header={header}
        hasSider={true}
        activeKey={activeTab}
        openSubMenu={openSubMenu}
        onChange={handleTabChange}
        hubConfig={hubConfig}
        hubUserRole={hubUserRole}
        onActionClick={onActionClick}
        navigationKey={navigationKey}
        offset={offset}
        limit={limit}
        renderProfileSection={renderProfileSection}
      >
        <div className="hub-details-wrapper page-content-wrapper">
          {renderHeader}
          <AccountSetupSection
            handleAssignSmartCamera={handleAssignSmartCamera}
            openAssignStaffModal={openAssignStaffModal}
            isSmartCameraModalOpen={isSmartCameraModalOpen}
            closeModal={closeModal}
            searchText={searchText}
            setSearchText={setSearchText}
            searchApplied={searchApplied}
            handleSearchApply={handleSearchApply}
            handleClearSearch={handleClearSearch}
            readyToAssignDevices={readyToAssignDevices}
            readyToAssignloading={readyToAssignloading}
            selectedSmartCameraDevice={selectedSmartCameraDevice}
            handleDeviceSmartCameraSelect={handleDeviceSmartCameraSelect}
            assignDevice={assignDevice}
            isFirstModalOpen={isFirstModalOpen}
            handleCloseFirstModal={handleCloseFirstModal}
            fetchingStaffList={fetchingStaffList}
            selectedStaff={selectedStaff}
            mOrderedStaffList={mOrderedStaffList}
            handleAddStaff={handleAddStaff}
            formData={formData}
            handleInputChange={handleInputChange}
            selectedUser={accountUserName}
            handleAssignStaff={handleAssignStaff}
            handleRoleSelection={handleRoleSelection}
            handleOpenSecondModal={handleOpenSecondModal}
            handleCloseSecondModal={handleCloseSecondModal}
            isSecondModalOpen={isSecondModalOpen}
            setSelectedStaff={setSelectedStaff}
            role={role}
            setActiveTab={setActiveTab}
            hubRecord={hubRecord}
            updatedUserInfo={updatedUserInfo}
            hasDevice={hasDevice}
            handleAssignSmartCameraList={handleAssignSmartCameraList}
            setHasDevice={setHasDevice}
            fetchDevices={fetchDevices}
            setDeviceStatus={setDeviceStatus}
            setDeviceLocation={setDeviceLocation}
            setStatusTitle={setStatusTitle}
            setHeaderRefreshKey={setHeaderRefreshKeyHandler}
            refetch={refetch}
            dataFetched={dataFetched}
            accessoriesData={accessoriesData}
            setSearchNameApplied={setSearchNameApplied}
            searchNameApplied={searchNameApplied}
            setSearchNameText={setSearchNameText}
            searchNameText={searchNameText}
            currentUser={currentUser}
            numOfAdminContacts={numOfAdminContacts}
            allowStaffAndStaffAdmin={allowStaffAndStaffAdmin}
            allowManageContacts={allowManageContacts}
          />
          <div className="hub-content-container">
            <div className="hubnewui-content-container">
              {activeTab === 'dashboard' && (
                <div className="hubnewui-dashboard-container">
                  <Dashboard
                    hubRecord={hubRecord}
                    timezone={updatedUserInfo?.timezone}
                    loginUserTimeformat={loginUserTimeformat}
                    loginUserMeasurementUnit={loginUserMeasurementUnit}
                  />
                </div>
              )}
              {activeTab === 'schedule' && (
                <div className="hubnewui-schedule-container">
                  <Schedule
                    onlyContent={true}
                    action={activeSubMenuContent === 'addEvent' ? Actions.addEvent : null}
                    hubRecord={hubRecord}
                    onActionClick={onActionClick}
                    rolename={rolename}
                    handleTabChange={handleTabChange}
                    openSubMenu={openSubMenu}
                    activeKey={activeTab}
                    userHubCall={userHubCall}
                    selectedUser={accountUserName}
                    loginUserTimeformat={loginUserTimeformat}
                    principalRecord={principalRecord}
                  />
                </div>
              )}
              {activeTab === 'contacts' && (
                <div className="hubnewui-contacts-container">
                  <Contacts
                    parentBread={header}
                    hubRecord={
                      navigationKey
                        ? filteredUserHubsData &&
                          filteredUserHubsData.length > 0 &&
                          filteredUserHubsData[0]
                        : hubRecord
                    }
                    onActionClick={onActionClick}
                    openSubMenu={openSubMenu}
                    handleTabChange={handleTabChange}
                    activeKey={activeTab}
                    userHubCall={userHubCall}
                    userHubsData={userHubsData}
                    principalRecord={principalRecord}
                  />
                </div>
              )}
              {activeTab === 'callActivity' && (
                <div className="hubnewui-callactivity-container">
                  <CallActivity
                    parentBread={header}
                    onActionClick={onActionClick}
                    hubRecord={hubRecord}
                    timezone={updatedUserInfo?.timezone}
                    loginUserTimeformat={loginUserTimeformat}
                  />
                </div>
              )}
              {activeTab === 'contentActivity' && (
                <div className="hubnewui-contentactivity-container">
                  <ContentActivity
                    parentBread={header}
                    onActionClick={onActionClick}
                    hubRecord={hubRecord}
                    timezone={updatedUserInfo?.timezone}
                    loginUserTimeformat={loginUserTimeformat}
                  />
                </div>
              )}
              {activeTab === 'motionactivity' && (
                <div className="hubnewui-motionactivity-container">
                  <MotionActivity
                    hubRecord={hubRecord}
                    timezone={updatedUserInfo?.timezone}
                    deviceStatus={deviceStatus}
                    loginUserTimeformat={loginUserTimeformat}
                    openSubMenu={openSubMenu}
                  />
                </div>
              )}
              {activeTab === 'environmental' && isSmartHomeEnabled && (
                <div className="hubnewui-environmental-container">
                  <SmartHome
                    userInfo={userInfo}
                    hubRecord={hubRecord}
                    timezone={updatedUserInfo?.timezone}
                    deviceStatus={deviceStatus}
                    loginUserTimeformat={loginUserTimeformat}
                    openSubMenu={openSubMenu}
                    loginUserMeasurementUnit={loginUserMeasurementUnit}
                  />
                </div>
              )}
              {activeTab === 'wellness' && isBiometricsEnabled && (
                <div className="hubnewui-wellness-container">
                  <Wellness
                    hubRecord={hubRecord}
                    timezone={updatedUserInfo?.timezone}
                    deviceStatus={deviceStatus}
                    providerid={providerid}
                    loginUserTimeformat={loginUserTimeformat}
                    loginUserMeasurementUnit={loginUserMeasurementUnit}
                    openSubMenu={openSubMenu}
                  />
                </div>
              )}
              {activeTab === 'gallery' && (
                <div className="hubnewui-gallery-container">
                  <Gallery hubRecord={hubRecord} />
                </div>
              )}
              {activeTab === 'deviceinventory' && (
                <div className="hubnewui-deviceinventory-container">
                  <DeviceInventory
                    hubRecord={hubRecord}
                    hubConfig={hubConfig}
                    hubUserRole={hubUserRole}
                    timezone={updatedUserInfo?.timezone}
                    deviceStatus={deviceStatus}
                    providerid={providerid}
                    loginUserTimeformat={loginUserTimeformat}
                    fetchDevices={fetchDevices}
                    devicesData={devicesData}
                    fetchUserHubs={fetchUserHubs}
                    headerRefreshKey={headerRefreshKey}
                    setHeaderRefreshKey={setHeaderRefreshKeyHandler}
                    queryParams={queryParams}
                    setDeviceStatus={setDeviceStatus}
                    setDeviceLocation={setDeviceLocation}
                    setStatusTitle={setStatusTitle}
                    hasDevice={hasDevice}
                    setHasDevice={setHasDevice}
                  />
                </div>
              )}
              {activeTab === 'editProfile' && (
                <div className="hubnewui-callactivity-container">
                  <EditUserProfile
                    parentBread={header}
                    hubRecord={hubRecord}
                    onActionClick={onActionClick}
                    openSubMenu={openSubMenu}
                    handleTabChange={handleTabChange}
                    userHubCall={userHubCall}
                    activeKey={activeTab}
                    showContactingStaff={showContactingStaff}
                    filteredUserHubsData={filteredUserHubsData}
                    successCallBack={successCallback}
                    parentActionClick={parentActionClick}
                    showStaffAccessBlocks={allowPersonalInfoAccessForAdmin}
                  />
                </div>
              )}
              {activeTab === 'inviteContact' && (
                <div className="hubnewui-contacts-container">
                  <ContactForm
                    parentBread={header}
                    hubRecord={hubRecord}
                    onActionClick={onActionClick}
                  />
                </div>
              )}
              {activeTab === 'assignStaff' && (
                <div className="hubnewui-callactivity-container">
                  <AssignStaff
                    record={hubRecord}
                    onActionClick={onActionClick}
                    openSubMenu={openSubMenu}
                    selectedUser={accountUserName}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </MainPage>
    </>
  );
};

HubDetailsComponent.propTypes = {
  header: PropTypes.arrayOf(PropTypes.object),
  hubRecord: PropTypes.object,
  onActionClick: PropTypes.func,
  principalRecord: PropTypes.object,
};

export default HubDetailsComponent;
